import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { translateService, signService } from "../../services/imports";
import { saveBlob } from "../../services/signService";

const t = (k, ...a) => translateService.t(`processes.evidence.${k}`, ...a);

// A signing's photo or liveness video shown in the page, for a dispute:
// fetched with the token when the viewer opens and held only while it is
// open (its object URL is revoked on close). "Download" saves the same file.
//
// props: processId, kind (photo | video), caption (the attempt's date and
// starter), onClose
export default class EvidenceViewer extends React.Component {
  state = { file: null, url: null, error: null, cannotShow: false };

  componentDidMount() {
    this.subscription = signService.getVerificationEvidence(this.props.processId, this.props.kind).subscribe(
      (file) => this.setState({ file, url: URL.createObjectURL(file.blob) }),
      (e) => this.setState({ error: signService.problemMessage(e, t("openError")) })
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
    if (this.state.url) URL.revokeObjectURL(this.state.url);
  }

  renderMedia() {
    const { url, error, cannotShow } = this.state;
    if (error)
      return (
        <p className="evidence-viewer__error" role="alert">
          {error}
        </p>
      );
    if (!url) return <img src="./assets/images/black-loading.svg" className="evidence-viewer__loading" alt="" />;
    if (cannotShow) return <p className="evidence-viewer__error">{t("cannotShow")}</p>;
    const failed = () => this.setState({ cannotShow: true });
    return this.props.kind === "video" ? (
      <video className="evidence-viewer__media" src={url} controls playsInline preload="metadata" onError={failed} />
    ) : (
      <img className="evidence-viewer__media" src={url} alt={t("photo")} onError={failed} />
    );
  }

  render() {
    const { kind, caption, onClose } = this.props;
    const file = this.state.file;
    return (
      <Modal isOpen fade={false} className={`evidence-viewer ${translateService.key}`} toggle={onClose}>
        <ModalHeader>
          <span>{t("viewerTitle", t(kind))}</span>
          {caption && <small className="evidence-viewer__caption">{caption}</small>}
        </ModalHeader>
        <ModalBody>
          <div className="evidence-viewer__stage">{this.renderMedia()}</div>
          <div className="buttons evidence-viewer__footer">
            {file && (
              <button type="button" className="button background-color-one color-white" onClick={() => saveBlob(file.blob, file.name)}>
                {translateService.t("common.download")}
              </button>
            )}
            <button type="button" className="button background-color-two color-white" onClick={onClose}>
              {translateService.t("common.close")}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
